import axios from 'axios';
import { CreditCardIcon, RadioButton } from 'dw-au-react-components';
import React, { useEffect, useState } from 'react';
import CartHeader from '../ShoppingCart/CartHeader';
import PayPalLogo from '../../svg/PayPalLogo';
import { CreditCardIconGroup } from '../CreditCardIconGroup';
import GoogleAnalytics from '../../Utils/ObjectUtils/GoogleAnalytics';

function MemberSelectPayment({
	setStep,
	userData,
	fetchUserData,
	handleMemberAddPayment,
	setNewCard,
	setPaymentMethod,
	paymentMethod,
	setLoading,
	enablePaypal,
	handleFormSubmission,
}) {
	let paymentWallet = userData?.trustedDetails?.paymentWallet;
	const [radioSelection, setRadioSelection] = useState(null);
	const [radioPaymentSelection, setRadioPaymentSelection] = useState('card');
	const [message, setMessage] = useState(null);

	useEffect(() => {
		getDefaultCard();
	}, []);

	// Get Default Card
	const getDefaultCard = () => {
		let filteredCard = paymentWallet.filter((card) => {
			return card.defaultPayment;
		});
		if (filteredCard.length > 0) {
			setRadioSelection(filteredCard[0]?.cardId);
		}
	};

	const onPaymentChange = (e) => {
		setRadioPaymentSelection(e.target.value);
		setRadioSelection(null);
		if (e.target.value === 'paypal') {
			handleFormSubmission('paypal');
			GoogleAnalytics.setEventTrackingGA4(
				'Contentful_Rec_Checkout_Existing_Click_Paypal'
			);
		}
	};

	const onRadioChange = (e) => {
		setRadioSelection(e.target.value);
		handlePaymentDefault(e.target.value);
	};

	useEffect(() => {
		if (paymentMethod && paymentMethod === 'paypal') {
			setRadioPaymentSelection('paypal');
		}
	}, [paymentMethod]);

	const handlePaymentDefault = (cardId = radioSelection) => {
		if (cardId) {
			updateCardMakeDefault(cardId);
			setMessage(null);
		} else {
			setMessage({ class: 'alert-danger', message: 'Select a Address' });
		}
	};

	const updateCardMakeDefault = (cardId) => {
		setLoading(true);

		axios
			.post(`/api/user/payment/${cardId}/options`, {
				options: ['DEFAULT_CARD'],
			})
			.then(() => {
				setLoading(false);
				fetchUserData();
				setMessage({
					class: 'alert-success',
					message: 'You have successfully updated your default card.',
				});
				setNewCard(null);
				setPaymentMethod('card');
				setTimeout(() => {
					setMessage(null);
					setStep(5);
				}, 1000);
			})
			.catch(() => {
				setMessage({
					class: 'alert-danger',
					message: 'Something went wrong!',
				});
				setTimeout(() => {
					setMessage(null);
				}, 2000);
			});
	};

	return (
		<div>
			<CartHeader title='Checkout' />
			{message && message?.class !== 'alert-success' && (
				<div className={`mb-20 alert ${message?.class}`}>{message.message}</div>
			)}
			<div className='text_big mb-16 text-dark-medium'>
				Select another card to change default payment option.
			</div>

			{enablePaypal && (
				<div className='text-small text-uppercase mb-15 font-helvetica paymentType__info'>
					Pay with Credit Card
				</div>
			)}

			{enablePaypal && (
				<div className='form-row d-flex mb-25'>
					<RadioButton
						cypressClass='card-radio'
						value='card'
						name='paymentType'
						isChecked={radioPaymentSelection === 'card' ? true : false}
						onChange={onPaymentChange}
						className='mb-0'
					/>
					<CreditCardIconGroup />
				</div>
			)}

			{radioPaymentSelection !== 'paypal' ? (
				<div className={enablePaypal ? 'pl-20' : ''}>
					{paymentWallet.length > 0 ? (
						<>
							<div className='subtitle mb-16 lower roboto'>Card Details</div>
							<div className='mb-40'>
								{paymentWallet
									// ?.sort((a, b) =>
									// 	a.defaultPayment > b.defaultPayment
									// 		? -1
									// 		: a.defaultPayment < b.defaultPayment
									// 		? 1
									// 		: 0
									// )
									.map((filteredPayment, index) => {
										return (
											<div className='mb-20' key={index}>
												<div className='d-flex align-items-center'>
													<RadioButton
														cypressClass='card-radio'
														value={filteredPayment.cardId}
														isChecked={
															radioSelection === filteredPayment.cardId
														}
														onChange={onRadioChange}
														className='mb-0'
													/>
													<div
														className='d-flex align-items-center cursor-pointer'
														onClick={() => {
															setRadioSelection(filteredPayment.cardId);
															handlePaymentDefault(filteredPayment.cardId);
														}}
													>
														<CreditCardIcon
															className='mr-25'
															cardType={filteredPayment?.cardType}
														/>

														<div className='text-dark-medium'>
															<div className='mb-10 text-dark-medium'>
																{filteredPayment?.cardNumber.replace(
																	/.{4}(?=.{4})/g,
																	'xxxx '
																)}
															</div>
															Expiry: {filteredPayment?.expirationMonth}/
															{filteredPayment?.expirationYear}
														</div>
													</div>
												</div>
												{message?.class === 'alert-success' &&
													radioSelection === filteredPayment.cardId && (
														<div className='mt-10 mb-40 text-green'>
															{message?.message}
														</div>
													)}
											</div>
										);
									})}
							</div>
							{/* <div
						className='text-red mb-40 cursor-pointer d-inline-block'
						onClick={handlePaymentDefault}
					>
						Change Default
					</div> */}
						</>
					) : (
						<div className='dmlp__form__input__error mb-25'>
							No Cards found.
						</div>
					)}
					<div
						type='submit'
						className='btn btn-primary font-weight-bold dmlp__btn w-100 mb-20'
						onClick={() => {
							setPaymentMethod('card');
							handleMemberAddPayment('', 9);
						}}
					>
						Add New Card
					</div>
				</div>
			) : null}
			{enablePaypal && (
				<>
					<div className='text-small text-uppercase mb-15 font-helvetica paymentType__info'>
						Pay with Paypal
					</div>

					<div className='form-row d-flex mb-20'>
						<RadioButton
							cypressClass='paypal-radio'
							value='paypal'
							name='paymentType'
							isChecked={radioPaymentSelection === 'paypal' ? true : false}
							onChange={onPaymentChange}
						/>
						<PayPalLogo />
					</div>
				</>
			)}
			<div
				className='btn btn-outline-secondary btn-block'
				onClick={() => {
					setStep(5);
				}}
			>
				Back to Checkout
			</div>
		</div>
	);
}

export default MemberSelectPayment;
